import { useState } from "react"
import { Box, Button, TextField } from "@mui/material"
import { useDispatch } from "react-redux"
import {createNewWorkspace} from "../../reducers/workspaceSlice"

export default function NewWorkspaceForm() {
	const dispatch = useDispatch()
	const [title, setTitle] = useState("")
	const [description, setDescription] = useState("")

	const handleSubmit = (event) => {
		event.preventDefault()
		dispatch(createNewWorkspace({title, description}))
	}
	return (
		<form onSubmit={(e) => handleSubmit(e)}>
			<Box  sx={{ display: "flex", flexDirection: "column", padding: "10px" }}>
				<TextField
					fullWidth
					required
					id="title"
					label="Title"
					onChange={(e) => setTitle(e.target.value)}
					value={title}
				/>
				<TextField
					fullWidth
					multiline
					rows={3}
					required
					id="description"
					label="Description"
					onChange={(e) => setDescription(e.target.value)}
					value={description}
					sx={{
						margin: "1rem 0"
					}}
				/>
				<Button variant={"contained"} type='submit'>
					Create Workspace
				</Button>
			</Box>
		</form>

	)
}
